// DOM-based (browser-only) HTML utilities. These rely on DOMParser and no-op on the
// server. For DOM-free, server-safe HTML helpers see `./server/html-utils.ts`.

export function parseTextToHtml(text: string): string {
	if (typeof window === 'undefined') return text;
	if (!text) return '';

	try {
		const paragraphs = text.split(/\n/).map((p) => `<p>${p.replace(/\n/g, '<br/>')}</p>`);
		const htmlString = paragraphs.join('');

		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlString, 'text/html');
		return doc.body.innerHTML;
	} catch (err) {
		console.error('Error in parseTextToHtml', err);
		return text;
	}
}

export function parseHtmlToPlainText(html: string): string {
	if (typeof window === 'undefined') return html;
	if (!html) return '';

	try {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');

		doc.querySelectorAll('br').forEach((br) => {
			br.replaceWith('\n');
		});

		doc.querySelectorAll('p').forEach((p) => {
			p.insertAdjacentText('afterend', '\n');
		});

		return doc.body.textContent || '';
	} catch (err) {
		console.error('Error in parseHtmlToPlainText', err);
		return html;
	}
}
